import React, { useState, useEffect, useCallback } from 'react';
import apiService from '../../../apiService';
import { ACTIVITY_META, ACTIVITY_ORDER, fmtMoney, fmtInt, Card, BarRow, Spinner, usePeriodControls } from '../financeShared';

export default function ByActivityTab({ currency, rate }) {
  const [activity, setActivity] = useState('taxi');
  const { params, qs, groupBy, controls } = usePeriodControls('1year', 'month');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fmt = (n) => fmtMoney(n, currency, rate);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`/admin/finance/by-activity?activity=${activity}&${qs()}`, { userType: 'admin' });
      if (res?.success) setData(res);
    } catch (e) { console.error('by-activity:', e); } finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activity, params]);
  useEffect(() => { load(); }, [load]);

  const timeline = data?.timeline || [];
  const breakdown = data?.breakdown || [];
  const total = data?.total || 0;
  const breakdownTitle = activity === 'subscriptions' ? 'Par plan' : activity === 'taxi' ? 'Par méthode de paiement' : 'Par fournisseur (top 15)';

  return (
    <>
      {/* Sélecteur d'activité */}
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
        {ACTIVITY_ORDER.map(k => (
          <button key={k} onClick={() => setActivity(k)}
            style={{ padding: '0.45rem 1rem', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '0.85rem', fontWeight: activity === k ? 700 : 600,
              background: activity === k ? ACTIVITY_META[k].color : '#f0f4f8', color: activity === k ? 'white' : '#414852' }}>
            {ACTIVITY_META[k].label}
          </button>
        ))}
      </div>
      {controls()}

      {loading ? <Spinner /> : (
        <>
          <Card style={{ marginBottom: '2rem', borderLeft: `4px solid ${ACTIVITY_META[activity].color}` }}>
            <p style={{ fontSize: '0.75rem', color: '#5C636E', textTransform: 'uppercase', fontWeight: 600, margin: 0 }}>CA {ACTIVITY_META[activity].label}</p>
            <p style={{ fontSize: '1.8rem', fontWeight: 700, color: ACTIVITY_META[activity].color, margin: '0.25rem 0 0' }}>{fmt(total)}</p>
          </Card>

          <Card style={{ marginBottom: '2rem' }}>
            <h3 style={{ marginBottom: '1.25rem', color: '#1E2229', fontSize: '1.05rem', fontWeight: 600 }}>{breakdownTitle}</h3>
            {breakdown.length === 0 ? <p style={{ color: '#9AA0A8' }}>Aucune donnée.</p> : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                {breakdown.map((b, i) => {
                  const pct = total > 0 ? (b.revenue / total) * 100 : 0;
                  return <BarRow key={b.key + i} label={`${b.label}${b.public_id ? ` (${b.public_id})` : ''}`} pct={pct} color={ACTIVITY_META[activity].color} valueText={`${fmt(b.revenue)} · ${fmtInt(b.count)}×`} />;
                })}
              </div>
            )}
          </Card>

          <Card>
            <h3 style={{ marginBottom: '1.25rem', color: '#1E2229', fontSize: '1.05rem', fontWeight: 600 }}>Évolution ({groupBy === 'month' ? 'par mois' : 'par jour'})</h3>
            {timeline.length === 0 ? <p style={{ color: '#9AA0A8' }}>Aucune donnée.</p> : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead><tr style={{ background: '#FFFFFF', borderBottom: '2px solid #E9EBEF' }}>
                    {['Période', 'Revenu', 'Volume'].map(h => (
                      <th key={h} style={{ padding: '0.75rem 1rem', textAlign: h === 'Période' ? 'left' : 'right', fontWeight: 700, color: '#414852', fontSize: '0.8rem', textTransform: 'uppercase' }}>{h}</th>
                    ))}
                  </tr></thead>
                  <tbody>
                    {timeline.slice().reverse().map((row, idx) => (
                      <tr key={row.period} style={{ borderBottom: '1px solid #E9EBEF', background: idx % 2 === 0 ? '#fff' : '#FFFFFF' }}>
                        <td style={{ padding: '0.7rem 1rem', color: '#1E2229', fontWeight: 600 }}>{row.period}</td>
                        <td style={{ padding: '0.7rem 1rem', textAlign: 'right', color: ACTIVITY_META[activity].color, fontWeight: 700 }}>{fmt(row.revenue)}</td>
                        <td style={{ padding: '0.7rem 1rem', textAlign: 'right', color: '#5C636E' }}>{fmtInt(row.count)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Card>
        </>
      )}
    </>
  );
}
